import { Link, useNavigate } from "react-router-dom";

export default function MiniHeader({ onClickArrowButton, onClickCrossButton }) {
	const navigate = useNavigate();

	const handleGoBack = () => {
		navigate(-1);
	};

	return (
		<header className="mini-header">
			<button
				className="mini-header__button"
				type="button"
				onClick={onClickArrowButton ? onClickArrowButton : handleGoBack}
			>
				<svg
					width="40"
					height="40"
					viewBox="0 0 40 40"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g opacity="0.8">
						<path
							d="M26.25 32.5L13.75 20L26.25 7.5"
							stroke="#1B1B1B"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</g>
				</svg>
			</button>

			<Link className="mini-header__logo" to="/">
				<img
					src={"/files/images/ui/logo_header.png"}
					alt="YouWanna - интернет-магазин одежды и аксессуаров"
				/>
			</Link>

			{onClickCrossButton && (
				<button
					className="mini-header__button"
					type="button"
					onClick={onClickCrossButton}
				>
					<svg
						width="40"
						height="40"
						viewBox="0 0 40 40"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g opacity="0.8">
							<path
								d="M10 30L30 10M10 10L30 30"
								stroke="#1B1B1B"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</g>
					</svg>
				</button>
			)}
		</header>
	);
}
